import React from "react";
import styles from "./Subscribe.module.css";

export function SubscribeMessage({ message }: { message: string }) {
  return (
    <div className={styles.pagePadding}>
      <div className={styles.panel}>
        <p className={styles.messageParagraph}>{message}</p>
      </div>
    </div>
  );
}
